var _defs, _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaginationLast(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SVGDoc",
    width: 18,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Generated with Avocode.")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Pfad 7671"), /*#__PURE__*/React.createElement("path", {
    d: "M8.97559,16.56055v0l7.5,-7.5v0l-7.5,-7.5v0",
    fillOpacity: 0,
    fill: "#ffffff",
    strokeDashoffset: 0,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeOpacity: 1,
    stroke: "currentColor",
    strokeMiterlimit: 20,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Pfad 7672"), /*#__PURE__*/React.createElement("path", {
    d: "M1.47559,16.56055v0l7.5,-7.5v0l-7.5,-7.5v0",
    fillOpacity: 0,
    fill: "#ffffff",
    strokeDashoffset: 0,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeOpacity: 1,
    stroke: "currentColor",
    strokeMiterlimit: 20,
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaginationLast);
export default __webpack_public_path__ + "static/media/pagination-last.951156f7.svg";
export { ForwardRef as ReactComponent };